module.exports = __webpack_public_path__ + "img/bg_contact.56a7f646.png";